import { useAuth } from '@/composables/auth'
import { env } from '@/env'
import { computed } from 'vue'
import { useConfig } from '@/composables/game/config'
import { isBaseMiniApp } from '@/services/base'
import { sdk } from '@farcaster/miniapp-sdk'
import webapp from '@/services/webapp'

export const useReferral = () => {
  const { config } = useConfig()

  const { profile } = useAuth()
  const referralUrl = computed(() => isBaseMiniApp ? `${env.base.miniappUrl}?rc=${profile.value.referralCode}` : `https://t.me/${env.bot.username}/${env.bot.appShortName}?startapp=ref_${profile.value.referralCode}`)
  const shareMessage = computed(() => env.bot.shareText.replace(/%normal_reward%/g, String(config.value.game.referrals.initialRefereeReward.normal)).replace(/%premium_reward%/g, String(config.value.game.referrals.initialRefereeReward.premium)))
  const shareUrl = computed(() => {
    const shareUrl = new URL('https://t.me/share/url')
    shareUrl.searchParams.set('url', referralUrl.value)
    shareUrl.searchParams.set('text', shareMessage.value)
    return shareUrl.toString().replace(/\+/g, '%20')
  })

  async function shareReferralUrl() {
    if (isBaseMiniApp) {
      await sdk.actions.composeCast({
        text: shareMessage.value,
        embeds: [referralUrl.value],
      })
    } else {
      webapp.openTelegramLink(shareUrl.value)
    }
  }

  return {
    shareUrl,
    shareReferralUrl,
    referralUrl,
  }
}
